<template>
  <div
    v-if="topCategories.length > 0"
    class="flex w-full flex-col gap-[34px] pb-0 pt-[60px] lg:flex-row lg:gap-[119px] lg:py-[90px]"
  >
    <div
      class="whitespace-nowrap text-lg font-medium leading-6 lg:text-2xl lg:leading-[46px]"
    >
      {{ $t('global.top_categories') }}:
    </div>
    <FlyoutMenuSecondColumn
      class="float-left w-full p-0"
      :category-children="topCategories"
      disable-tracking
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { MAIN_CATEGORY_ROOT_IDS } from '#layers/base/constants/scayle'
import useRootCategories from '#layers/base/composables/useRootCategories'

const props = defineProps<{ categoryName?: string }>()

const { data } = useRootCategories()

const topCategories = computed(() => {
  const mainCategoryChildren =
    data.value?.categories
      ?.filter((category) => MAIN_CATEGORY_ROOT_IDS.includes(category.id))
      .flatMap((category) => category.children ?? []) ?? []

  if (props.categoryName) {
    const match = mainCategoryChildren.find(
      ({ name }) => name === props.categoryName,
    )
    return match ? [match] : []
  }

  return mainCategoryChildren
})
</script>
